import React from 'react';
import classNames from 'classnames';

function CardContentImagePlay({ time }) {
  return <div className={classNames('image__play', { 'has-time': time })}>{time && <span>{time}</span>}</div>;
}

export default CardContentImagePlay;
